import axios from 'axios'

import { getBaseHref } from '../shared/env'
import { escHtml } from '../shared/utils'

/* Constsnts */
const STEP__FORM = 'form'
const STEP__SUCCESS = 'success'

/* Elements */
let wrapperEl
let formEl
let errorMessageEl

const onDomContentLoaded = () => {
    /* Elements */
    wrapperEl = document.querySelector('.content-lib-user-registration')
    if (wrapperEl) {
        init()
    }
}

const init = () => {
    /* Elements (assumed to be present) */
    formEl = wrapperEl.querySelector('form')
    errorMessageEl = wrapperEl.querySelector('.submit-side-text .error-message')

    /* Event listeners */
    formEl.addEventListener('submit', onFormSubmit)

    /* Everything ready, activate the form */
    setStepActive(STEP__FORM)
}

const onFormSubmit = async (event) => {
    event.preventDefault()

    /* Clear any previous error message */
    setErrorMessages([])
    highlightFieldsWithError([])

    /* Submit the form (todo) */
    let response
    try {
        response = await axios.post(
            getBaseHref() + 'ajax/lib-user-registration/submit',
            new FormData(formEl),
        )
        if (response.status === 200 && response.data.success) {
            setStepActive(STEP__SUCCESS)
        } else {
            throw new Error('Unexpected response status: ' + response.status)
        }
    } catch (error) {
        if (error.response && error.response.status === 422) {
            setErrorMessages(error.response.data.messages)
            highlightFieldsWithError(error.response.data.fields_with_error)
        } else {
            console.error(error)
            setErrorMessages(['Ha sucedido un error inseperado.'])
        }
    }
}

const setErrorMessages = (messages) => {
    errorMessageEl.innerHTML = escHtml(messages.join('\n'))
}

const highlightFieldsWithError = (fields) => {
    const formGroupEls = formEl.querySelectorAll('.form-group')
    formGroupEls.forEach(formGroupEl => {
        const controlEl = formGroupEl.querySelector('[name]')
        if (controlEl && fields.includes(controlEl.name)) {
            formGroupEl.classList.add('form-group-error')
        } else {
            formGroupEl.classList.remove('form-group-error')
        }
    })
}

const setStepActive = (step) => {
    const stepWrapperEls = wrapperEl.querySelectorAll('.step-wrapper')
    stepWrapperEls.forEach((stepWrapperEl, index) => {
        if (stepWrapperEl.classList.contains('step-' + step)) {
            stepWrapperEl.classList.add('step-wrapper-active')
        } else {
            stepWrapperEl.classList.remove('step-wrapper-active')
        }
    })
}

addEventListener('DOMContentLoaded', onDomContentLoaded)
